import React from 'react';
import '../css/MarketSpace.css';
import { connect } from 'react-redux';
import Next from '../assets/images/next.png';
import * as ActionTypes from '../actions/types';
import { is_allowed } from '../utilitis';

class MarketSpace extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      loader: true,
      activeData: [],
      actualData: [],
      snackbarActive: false,
      snackbarMessage: ''
    };
  }


  componentDidMount() {
    this.fetchActiveService()

  }


  fetchActiveService = () => {
    this.setState({
      loader: true
    });

    const tokenStored = localStorage.getItem('token');
    const headers = {
      "Authorization": `Token ${tokenStored}`,
      'X-CSRFToken': localStorage.getItem('csrftoken')
    };

    fetch('/cloud/apps/', {
      method: 'GET',
      headers: headers,
    })
      .then(response => {
        if (response.status === 403) {
          // Remove session data
          localStorage.removeItem('token');
          localStorage.removeItem('csrftoken');
          localStorage.removeItem('auth');

          // Redirect to session timeout page
          window.location.href = '/session-timeout';
        } else {
          return response.json();
        }
      })
      .then(data => {
        // console.log(data);
        // Set the activeData and log the fetched data directly
        this.setState({
          activeData: data,
          loader: false
        });

        // Log the fetched data directly here
        // console.log(this.state.activeData);  // This will print the correct data
      })
      .catch((err) => {
        console.log(err);
        this.setState({ loader: false });
      });
  };

  render() {
    return (
      <div className="section-background">
        {/* Header Section */}

        {(
          localStorage.getItem("user_type") === "1" ||
          (
            localStorage.getItem("user_type") === "2" &&
            is_allowed(this.props.redux.permissions.permissions, localStorage.getItem("user_type"), "market place", "add")
          )
        ) && (

            <div className='add-button-container'>
              <a style={{ textDecoration: 'none' }} href='/marketspaceForm' className='add-button'>
                <span className='plus-sign'>+</span>

              </a>
              <a style={{ textDecoration: 'none' }} href='/marketspaceForm'><span className='add-text'>ADD NEW</span></a>
            </div>)}

        <div className="remote-access-section">

          {this.state.activeData && this.state.activeData.length > 0 ? (
            this.state.activeData
              .filter((app) => app.status === 'active') // Filter active apps
              .map((app) => {
                const activeUserInfo = `Non-active: ${app.downloads} Downloads | ${app.active_users} Active Users`;

                return (
                  <a style={{ textDecoration: 'none' }} key={app.id} href={`/marketspacedownload?id=${app.id}`}>
                    <div className="remote-access-container">
                      <div className="remote-access-illustration">
                        <img
                          src={app.banner_image}
                          alt={app.name}
                          className="illustration-image"
                          style={{ width: '180px', height: '180px', objectFit: 'contain' }}
                        />
                      </div>
                      <div className="remote-access-info">
                        <h3>{app.name}
                          <span className='active-edit-button'>
                            {/* <a style={{ textDecoration: 'none' }} href={`/marketspaceForm?id=${app.id}`} className='add-button'>
                              <img src={Next} style={{ height: '15px', width: '15px' }}></img>
                            </a> */}
                            <a
                              href={(
                                localStorage.getItem("user_type") === "1" ||
                                (
                                  localStorage.getItem("user_type") === "2" &&
                                  is_allowed(this.props.redux.permissions.permissions, "2", "market place", "edit")
                                )
                              ) ? `/marketspaceForm?id=${app.id}` : '#'}
                              onClick={(e) => {
                                const hasAccess =
                                  localStorage.getItem("user_type") === "1" ||
                                  (
                                    localStorage.getItem("user_type") === "2" &&
                                    is_allowed(this.props.redux.permissions.permissions, "2", "market place", "edit")
                                  );

                                if (!hasAccess) {
                                  e.preventDefault(); // Prevent redirect
                                  alert("You don't have permission to access this page.");
                                }
                              }}
                              style={{
                                textDecoration: 'none',
                                pointerEvents: (
                                  localStorage.getItem("user_type") === "1" ||
                                  (
                                    localStorage.getItem("user_type") === "2" &&
                                    is_allowed(this.props.redux.permissions.permissions, "2", "market place", "edit")
                                  )
                                ) ? 'auto' : 'none',
                                opacity: (
                                  localStorage.getItem("user_type") === "1" ||
                                  (
                                    localStorage.getItem("user_type") === "2" &&
                                    is_allowed(this.props.redux.permissions.permissions, "2", "market place", "edit")
                                  )
                                ) ? 1 : 0.4,
                                cursor: (
                                  localStorage.getItem("user_type") === "1" ||
                                  (
                                    localStorage.getItem("user_type") === "2" &&
                                    is_allowed(this.props.redux.permissions.permissions, "2", "market place", "edit")
                                  )
                                ) ? 'pointer' : 'not-allowed',
                              }}
                              className='add-button'
                            >
                              <img src={Next} style={{ height: '15px', width: '15px' }} alt="next" />
                            </a>

                          </span>
                        </h3>

                        <p>{app.features}</p>
                        {/* <p>{app.description}</p> */}
                        {/* <br /> */}
                        <p>{activeUserInfo}</p>
                        <a style={{ textDecoration: 'none' }} key={app.id} href={`/marketspacedownload?id=${app.id}`} className="more-link">More...</a>
                      </div>
                    </div>
                  </a>
                );
              })
          ) : (
            <p>No active apps available.</p> // Fallback text if no active apps are available
          )}
        </div>

        <div className="apps-in-draft-container">
          <h3>APPS IN DRAFT</h3>

          {/* <span className='add-text' style={{marginBottom: "50px"}}>APPS IN DRAFT</span> */}
          <br />
          <div className="grid-container">
            {this.state.activeData && this.state.activeData.length > 0 ? (
              this.state.activeData
                .filter((app) => app.status === 'inactive') // Only apps with 'archived' status will be displayed
                .map((app) => {
                  // Format the string for active users, downloads, and status
                  const activeUserInfo = `NON ACTIVE | ${app.downloads} DOWNLOADS | ${app.active_users} ACTIVE USERS`;

                  return (
                    <div key={app.id} className="grid-item">
                      <div className="image-container">
                        <img
                          src={app.banner_image ? app.banner_image : 'https://via.placeholder.com/150'} // Fallback image if no banner_image

                          alt={app.name}
                          style={{ width: '100px', height: '100px', objectFit: 'contain', backgroundColor: '#F6EEF9' }}
                        />
                      </div>

                      <div className="info-container">
                        <div className="name-and-button">
                          <h4>{app.name}</h4>

                        </div>
                        <p>{app.features}</p>
                        <p style={{ fontStyle: "italic" }}>{app.description}</p>
                        <p style={{ fontSize: "11px" }}>{activeUserInfo}</p>
                        <div className="view-details">
                          <a href={`/marketspacedownload?id=${app.id}`} className="more-link-small">More...</a>
                        </div>
                      </div>
                      {/* <a href={`/marketspaceForm?id=${app.id}`} style={{ width: "50px", textDecoration: 'none' }} className='add-button'>
                        <img src={Next} style={{ height: '15px', width: '15px' }}></img>
                      </a> */}
                      <a
                        href={(
                          localStorage.getItem("user_type") === "1" ||
                          (
                            localStorage.getItem("user_type") === "2" &&
                            is_allowed(this.props.redux.permissions.permissions, localStorage.getItem("user_type"), "market place", "edit")
                          )
                        ) ? `/marketspaceForm?id=${app.id}` : '#'}
                        onClick={(e) => {
                          const hasAccess =
                            localStorage.getItem("user_type") === "1" ||
                            (
                              localStorage.getItem("user_type") === "2" &&
                              is_allowed(this.props.redux.permissions.permissions, localStorage.getItem("user_type"), "market place", "edit")
                            );

                          if (!hasAccess) {
                            e.preventDefault(); // block navigation
                            alert("You do not have permission to access this page.");
                          }
                        }}
                        style={{
                          width: "50px",
                          textDecoration: 'none',
                          pointerEvents: (
                            localStorage.getItem("user_type") === "1" ||
                            (
                              localStorage.getItem("user_type") === "2" &&
                              is_allowed(this.props.redux.permissions.permissions, localStorage.getItem("user_type"), "market place", "edit")
                            )
                          ) ? 'auto' : 'none',
                          opacity: (
                            localStorage.getItem("user_type") === "1" ||
                            (
                              localStorage.getItem("user_type") === "2" &&
                              is_allowed(this.props.redux.permissions.permissions, localStorage.getItem("user_type"), "market place", "edit")
                            )
                          ) ? 1 : 0.4,
                          cursor: (
                            localStorage.getItem("user_type") === "1" ||
                            (
                              localStorage.getItem("user_type") === "2" &&
                              is_allowed(this.props.redux.permissions.permissions, localStorage.getItem("user_type"), "market place", "edit")
                            )
                          ) ? 'pointer' : 'not-allowed',
                        }}
                        className='add-button'
                      >
                        <img src={Next} style={{ height: '15px', width: '15px' }} alt="next" />
                      </a>


                    </div>
                  );
                })
            ) : (
              <p>No apps available in draft.</p> // Fallback text if no apps are available
            )}
          </div>
        </div>



      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    redux: state,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    searchBarActivate: (data) =>
      dispatch({ type: ActionTypes.SEARCHBAR, data: data }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MarketSpace);
